import { UIFont } from "./ui-font.js";

// ui-tap.class.js
// Converted from prototype-style UITAP to an ES module class.
// Source: ui-tap.js :contentReference[oaicite:1]{index=1}

export class UIMain {
    constructor(highlighter, data, lng="at") {
      this.highlighter = highlighter;
      this.data = data;
      this.contentLng = lng;
      this.currentStory = null;
      this.infoIds = [
        "zaps", "help", "legals", "about", "homescreen",
        "tours", "download", "back", "endoftour", "startoftour",
        "demo", "distance",
      ];
      this.generalConfig= {};
      this.generalConfig.singleZapMode= true;
    }
  
    _createHTMLFS() {
      const html = `<div id="testcontent">
          <div class="tourapic intro">
              <!-- NEU! .intro -->
              <div class="fontwrap">
                  <!-- NEU!.fontwrap  -->
  
                  <div class="viewer tap-view" id="container"></div>
              </div>
  
          </div>
      </div>`;
      const info  = document.getElementById("info");
      info.innerHTML=html;
  
    }
  
    
  
    _createHTML() {
      const html = `<div id="testcontent">
          <div class="tourapic intro" >
              <!-- NEU! .intro -->
              <div class="fontwrap">
                  <!-- NEU!.fontwrap  -->
                  <div id="intro">
                  <div id="sprachMenu" class="sprachMenu">
  
                  </div>
                  <div id="startscreen" style="display:none">
                      <div id="startscreenOben"><img src="images/bespoke_startlogo_1.png" class="startscreenLogo hoch"><img src="images/bespoke_startlogo_2.png" class="startscreenLogo quer"></div>
                      <div id="startscreenUnten">
                          <div id="sscrUs" class="usButt"><a href="" title="Ausstellungs Ãbersicht"><img src="images/nix.png" alt="Ãbersicht"></a></div>
                          <div id="sscrStart"><a href="" class="startTourButt" title="Tour Starten">Tour starten</a></div>
                          <div id="sscrSp" class="languageButt">
                              <a href="" title="Sprachauswahl"><img src="images/nix.png" alt="Sprachauswahl"></a>
  
                          </div>
                          <div id="sscrTapLogo"><a href="https://tourapic.com" title="Mehr erfahren auf tourapic.com"><img src="images/tap_logo_ws.png" alt="Logo: tour-a-pic"></a></div>
                          <div class="bla"><a href="#" class="impressumButtstart" title="Impressum">Impressum</a><a href="#" class="datenschutzButtstart" title="Datenschutz">Datenschutz</a><a href="#" class="cookiesButtstart" title="Cookies">Cookies</a></div>
                      </div>
                  </div>
                  <div id="impressum" class="startOl">
                      <div class="closebutton"><a href="" title="Schließen"><img src="images/nix.png" alt="Schließen"></a></div>
                      <div class="cont">
                          <h1>IMPRESSUM</h1>
                      </div>
                  </div>
                  <div id="datenschutz" class="startOl">
                      <div class="closebutton"><a href="" title="Schließen"><img src="images/nix.png" alt="Schließen"></a></div>
                      <div class="cont">
                          <h1>Datenschutz</h1>
                      </div>
                  </div>
                  <div id="cookies" class="startOl">
                      <div class="closebutton"><a href="" title="Schließen"><img src="images/nix.png" alt="Schließen"></a></div>
                      <div class="cont">
                          <h1>COOKIES</h1>
                      </div>
                  </div>
  
                  <div id="uebersichtWrap">
                      <div id="closeUs"><a href="" title="Close"><img src="images/nix.png" alt="Übersicht schliessen"></a></div>
                      <div id="uebersicht" class="ol">
                          <div id="uebersichtGrid">
                              <div class="uebersichtItem emptyItem"></div>
                          </div>
                      </div>
                  </div>
                  </div>
                  <div id="tourapicGrid" class="tourapicGrid" style="display:grid">
                      <div class="viewer tap-view" id="container"></div>
                      <div class="header">
                          <div class="logo"><img src="" alt="Logo"></div>
                          <div class="headline"><a href="#" title="testlink"><h1></h1></a></div>
                          <div class="listButton"><a href="#" class="uiButt" title="Menu"><img src="images/nix.png" alt="Menu"></a></div>                         
                          <hr>
                      </div>
                      <div class="ui" id="ui"  style="display:none">
                      </div>
                      <div class="mainWrap">
                          <div class="content main scroll-container activ">
                          </div>
                          <div class="taps main">
                          </div>
                          <div class="menu main">
                          </div>
                          <div class="help main">
                              <button id="increaseFont">Schriftgröße erhöhen</button>
                              <button id="decreaseFont">Schriftgröße verringern</button>
                              <div id="content">
                              <br><br>Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue.
                              </div>
                          </div>
                          <div class="language main">
                              <h2>SPRACHAUSWAHL</h2>
                              <div class="sprachMenu">
                              </div>
                          </div>
  
                          <div class="impressum main"><h1>Impressum</h1></div>
                          <div class="datenschutz main"><h1>Datenschutz</h1></div>
                          <div class="cookies main"><h1>Cookies</h1></div>
  
                      </div>
                      <div class="footer">
                          <div id="copyright">
                              <a href="#" class="butt impressumButt" title="Impressum">Impressum</a>
                              <a href="#" class="butt datenschutzButt" title="Datenschutz">Datenschutz</a>
                              <a href="#" class="butt cookieButt" title="Cookies">Cookies</a>
                          </div>
                          <div id="share">
                              <div id="somWrap" class="">
                                  <div class="som somFb"><a href="#" target="_blank" title="facebook"><img src="images/nix.png" alt="facebook"></a></div>
                                  <div class="som somInsta"><a href="#" target="_blank" title="insta"><img src="images/nix.png" alt="insta"></a></div>
                                  <div class="som somTick"><a href="#" target="_blank" title="tiktok"><img src="images/nix.png" alt="tiktok"></a></div>
                              </div>
                              <a href="#" class="share" target="_blank" title="Auf Socialmedia teilen ..."><img src="images/nix.png" alt="Icon: share/teilen"></a>
                          </div>
  
                      </div>
                  </div>
              </div>
  
          </div>
      </div>
  `;
  
      const ui2 = `                       <div class="submenu">
                              <div class="but helpButt"><a href="#" class="uiButt uiSubmenuButt" title="Hilfe"><img src="images/nix.png" alt="Hilfe"></a></div>
                              <div class="but languageButt"><a href="#" class="uiButt uiSubmenuButt" title="Sprachauswahl"><img src="images/nix.png" alt="Sprachauswahl"></a></div>
                          </div>
                          <div class="backnext">
                              <div class="back"><a href="#" class="uiButt" title="zurück"></a></div>
                              <div class="next"><a href="#" class="uiButt" title="weiter"></a></div>
                          </div>
                          <div class="listButton"><a href="#" class="uiButt" title="Menu"><img src="images/nix.png" alt="Menu"></a></div>
                          <div class="updown">
                              <div class="up"><a href="#" class="uiButt" title="mehr Text"><img src="images/nix.png" alt="mehr Text"></a></div>
                              <div class="down"><a href="#" class="uiButt" title="Weniger Text"><img src="images/nix.png" alt="weniger Text!"></a></div>
                          </div>
  `;
  
    const info  = document.getElementById("info");
    info.innerHTML=html;

    
    const ui  = document.getElementById("ui");
    ui.innerHTML=ui2;
   }
  
    _initHTMLEdit() {
      this._scrollTimer = null;
      this._lastActiveId = null;
      this.tourapicGrid = document.querySelector("#tourapicGrid");
      this.tapView = document.querySelector(".tap-view");
    
    }
  
    _initHTMLRaw() {
      this._scrollTimer = null;
      this._lastActiveId = null;
      this.tourapicGrid = document.querySelector("#tourapicGrid");
      this.tapView = document.querySelector(".tap-view");
   
    }
  
    _initHTML() {
      this._scrollTimer = null;
      this._lastActiveId = null;
  
      this.tourapicGrid = document.querySelector("#tourapicGrid");
      this.mainWrap = document.querySelector(".mainWrap");
      this.footer = document.querySelector(".footer");
      this.header = document.querySelector(".header");
      this.ui = document.querySelector(".ui");
      this.startTourButton = document.querySelector(".startTourButt");
      this.startscreen = document.getElementById("startscreen");
      this.startscreenUnten = document.getElementById("startscreenUnten");
      this.uebersichtWrap = document.getElementById("uebersichtWrap");
      this.uebersichtItems = document.querySelectorAll(".uebersichtItem");
      this.upButton = document.querySelector(".up");
      this.downButton = document.querySelector(".down");
      this.languageContainer = document.getElementById("sscrSp");
      this.sprachMenu = document.getElementById("sprachMenu");
      this.shareContainer = document.querySelector("#share");
      this.shareButton = document.querySelector(".share");
      this.somWrap = document.getElementById("somWrap");
      this.sscrUsLink = document.querySelector("#sscrUs a");
      this.closeUsLink = document.querySelector("#closeUs");
      this.listButton = document.querySelector(".listButton a.uiButt");
      this.langButton = document.querySelector(".languageButt a.uiButt");
      this.helpButton = document.querySelector(".helpButt a.uiButt");
      this.impButton = document.querySelector(".impressumButt");
      this.daschuButton = document.querySelector(".datenschutzButt");
      this.cookieButton = document.querySelector(".cookieButt");
      this.cookieMain = document.querySelector(".cookies.main");
      this.helpMain = document.querySelector(".help.main");
      this.langMain = document.querySelector(".language.main");
      this.menuMain = document.querySelector(".menu.main");
      this.tapsMain = document.querySelector(".taps.main");
      this.contentMain = document.querySelector(".content.main");
      this.impMain = document.querySelector(".impressum.main");
      this.daschuMain = document.querySelector(".datenschutz.main");
      this.tapView = document.querySelector(".tap-view");
      this.back = document.querySelector(".back");
      this.next = document.querySelector(".next");
      this.headline = document.querySelector(".headline");
      this.sscrSpLink = document.querySelector("#sscrSp a");
      this.flagLinks = document.querySelectorAll("#sprachMenu a.flag");
  
      this.increaseFont = document.querySelector("#increaseFont");
      this.decreaseFont = document.querySelector("#decreaseFont");
  
      this.scrollContainer = document.querySelector(".scroll-container");
  
      this.aFlag = document.querySelector("a.flag");
      this.imgFlag = document.querySelectorAll("img.flag");
  
      this.helpHc = document.querySelector(".hotcorner a.helpButt");
      this.usHc = document.querySelector(".hotcorner a.usButt");
      this.menuHc = document.querySelector(".hotcorner a.menuButt");
      this.languageHc = document.querySelector(".hotcorner a.languageButt");
    }
  
    init(mode) {
      
      switch (mode) {
        case "expert":
        case "edit":
          this._createHTMLFS();
          this._initHTMLEdit();
          break;
        case "raw":
          this._createHTMLFS();
          this._initHTMLRaw();
          break;
        default:
          this._createHTML();
          this._initHTML();
          this.initSprachen();
          this.setHeader();
          this.setLogo();
          const firstStory = this.data.RAW?.stories?.[0] ?? null;
          if (firstStory) {
            this.currentStory = firstStory; 
            this.initAllInfosByTour(firstStory)
          }
         
          this._attachEventHandlers();
      }
  
      this.UIFont = new UIFont();
      this.UIFont.updateFontSize();
    }
  
    _attachEventHandlers() {
      const self = this;
  
      // IMPRESSUM (startscreen) show
      document
        .querySelector(".bla .impressumButtstart")
        .addEventListener("click", function (event) {
          event.preventDefault();
          document.querySelector("#impressum").classList.add("ol");
        });
  
      // IMPRESSUM (startscreen) close
      document
        .querySelector("#impressum .closebutton")
        .addEventListener("click", function (event) {
          event.preventDefault();
          document.querySelector("#impressum").classList.remove("ol");
        });
  
      // DATENSCHUTZ (startscreen) show
      document
        .querySelector(".bla .datenschutzButtstart")
        .addEventListener("click", function (event) {
          event.preventDefault();
          document.querySelector("#datenschutz").classList.add("ol");
        });
  
      // DATENSCHUTZ (startscreen) close
      document
        .querySelector("#datenschutz .closebutton")
        .addEventListener("click", function (event) {
          event.preventDefault();
          document.querySelector("#datenschutz").classList.remove("ol");
        });
  
      // COOKIES (startscreen) show
      document
        .querySelector(".bla .cookiesButtstart")
        .addEventListener("click", function (event) {
          event.preventDefault();
          document.querySelector("#cookies").classList.add("ol");
        });
  
      // COOKIES (startscreen) close
      document
        .querySelector("#cookies .closebutton")
        .addEventListener("click", function (event) {
          event.preventDefault();
          document.querySelector("#cookies").classList.remove("ol");
        });
  
      // Click outside language menu closes it
      document.addEventListener("click", (event) => {
        event.preventDefault();
        if (
          self.sprachMenu.classList.contains("ol") &&
          !self.sprachMenu.contains(event.target) &&
          event.target !== self.sscrSpLink
        ) {
          self.hideMenu();
        }
      });
  
      // Read clicked overview item
      document.addEventListener("click", function (event) {
        const item = event.target.closest(".uebersichtItem");
        if (item) {
          const link = item.querySelector("a.usItem");
          if (link) {
            const title = link.getAttribute("title");
            // NOTE: clickOInfo is global in your original code; kept as-is.
            // eslint-disable-next-line no-undef
            clickOInfo = title;
          }
        }
      });
  
      // DOMContentLoaded
      document.addEventListener("DOMContentLoaded", function () {
        // NOTE: currentLng is global in your original code; kept as-is.
        // eslint-disable-next-line no-undef
        currentLng = self.initSprachen();
        // eslint-disable-next-line no-undef
        self.currentLng = currentLng;
  
        const mainWrap = document.querySelector(".mainWrap");
        const observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.attributeName === "class") {
              const target = mutation.target;
              if (target.classList.contains("activ")) {
                mainWrap.scrollTop = target.offsetTop;
              }
            }
          });
        });
  
        const mainDivs = document.querySelectorAll(".mainWrap .main");
        mainDivs.forEach(function (div) {
          observer.observe(div, { attributes: true });
        });
      });
  
      window.addEventListener("updateOverlayContent", (event) => {
        while (self.contentMain.firstChild) {
          self.contentMain.removeChild(self.contentMain.firstChild);
        }
        const h1 = document.createElement("h1");
        self.contentMain.appendChild(h1);
        const p = document.createElement("span");
        self.contentMain.appendChild(p);
        const lng = event.detail.infoitem.lngs[self.currentLng];
        h1.innerHTML = lng ? lng.title : "";
        p.innerHTML = lng ? lng.content : "";
      });
  
      if (this.increaseFont) {
        this.increaseFont.addEventListener("click", () => self.UIFont.increaseFont());
      }
  
      if (this.decreaseFont) {
        this.decreaseFont.addEventListener("click", () => self.UIFont.decreaseFont());
      }
  
      this.sscrSpLink.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        self.showMenu();
      });
  
      this.flagLinks.forEach((link) => {
        link.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          self.hideMenu();
        });
      });
  
      this.sprachMenu.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
      });
  
      // Start Button
      this.startTourButton.addEventListener("click", function (event) {
        event.preventDefault();
        self.startTap();
      });
  
      if (this.back) this.back.addEventListener("click", () => self.updateNavigation());
      if (this.next) this.next.addEventListener("click", () => self.updateNavigation());
  
      // SHARE Button show/hide
      this.shareButton.addEventListener("click", function (event) {
        event.preventDefault();
        self.somWrap.classList.toggle("activ");
        self.shareContainer.classList.toggle("activ");
      });
  
      this.somWrap.addEventListener("click", function (event) {
        event.preventDefault();
        if (event.target.tagName === "A") {
          self.shareContainer.classList.remove("activ");
          self.somWrap.classList.remove("activ");
        }
      });
  
      // IMPORTANT: bind "this" for methods that were used as callbacks in prototype version
      this.sscrUsLink.addEventListener("click", this.openUebersicht.bind(this));
      this.closeUsLink.addEventListener("click", this.closeUebersicht.bind(this));
  
      this.uebersichtItems.forEach((item) => {
        item.addEventListener("click", this.closeUebersicht2.bind(this));
      });
  
      // UP DOWN
      if (this.upButton)
        this.upButton.addEventListener("click", function (event) {
          event.preventDefault();
          self.tourapicGrid.classList.add("updownUp");
        });
  
      if (this.downButton)
        this.downButton.addEventListener("click", function (event) {
          event.preventDefault();
          self.tourapicGrid.classList.remove("updownUp");
        });
  
      // MENU
      this.listButton.addEventListener("click", function (event) {
        event.preventDefault();
        if (!self.tourapicGrid.classList.contains("activeMenu")) {
          self.resetButton();
          if (self.generalConfig.singleZapMode) {
            self.langMain.classList.add("activ");
            self.langButton.classList.add("activ");
          } else {
            self.tapsMain.classList.add("activ");
          }
        } else if (
          self.tourapicGrid.classList.contains("activeMenu") &&
          self.listButton.classList.contains("notClose")
        ) {
          self.resetButton();
        } else if (self.tourapicGrid.classList.contains("activeMenu")) {
          self.tourapicGrid.classList.remove("activeMenu");
          self.ui.classList.remove("activeMenu");
          document.querySelectorAll(".main").forEach((element) => element.classList.remove("activ"));
          self.daschuButton.classList.remove("activ");
          self.impButton.classList.remove("activ");
          self.listButton.classList.remove("activ");
          self.listButton.classList.remove("notClose");
          self.contentMain.classList.add("activ");
        }
      });
  
      // HELP show/hide
      this.helpButton.addEventListener("click", function (event) {
        event.preventDefault();
        self.resetButton();
        self.helpMain.classList.add("activ");
        self.helpButton.classList.add("activ");
      });
  
      // HOTCORNER - LANGUAGE show/hide
      if (this.languageHc)
        this.languageHc.addEventListener("click", function (event) {
          event.preventDefault();
          self.resetButton();
          self.langMain.classList.add("activ");
          self.langButton.classList.add("activ");
        });
  
      // HOTCORNER - HELP show/hide
      if (this.helpHc)
        this.helpHc.addEventListener("click", function (event) {
          event.preventDefault();
          self.resetButton();
          self.helpMain.classList.add("activ");
          self.helpButton.classList.add("activ");
        });
  
      // HOTCORNER - ÜBERSICHT show/hide
      if (this.usHc)
        this.usHc.addEventListener("click", function (event) {
          event.preventDefault();
          self.startscreen.style.display = "grid";
          self.uebersichtWrap.style.display = "block";
          self.startscreen.classList.add("ol");
          self.startscreenUnten.classList.add("nol");
          self.uebersichtWrap.classList.add("ol");
          self.resetButton();
        });
  
      // HOTCORNER - MENU show/hide
      if (this.menuHc)
        this.menuHc.addEventListener("click", function (event) {
          event.preventDefault();
          self.resetButton();
          self.menuMain.classList.add("activ");
        });
  
      // SPRACHE show/hide
      this.langButton.addEventListener("click", function (event) {
        event.preventDefault();
        if (self.tourapicGrid.classList.contains("activeMenu")) {
          self.resetButton();
          self.langMain.classList.add("activ");
          self.langButton.classList.add("activ");
        }
      });
  
      // IMPRESSUM show/hide
      this.impButton.addEventListener("click", function (event) {
        event.preventDefault();
        self.resetButton();
        self.impMain.classList.add("activ");
        self.impButton.classList.add("activ");
      });
  
      // DATENSCHUTZ show/hide
      this.daschuButton.addEventListener("click", function (event) {
        event.preventDefault();
        self.resetButton();
        self.daschuMain.classList.add("activ");
        self.daschuButton.classList.add("activ");
        self.listButton.classList.add("activ");
      });
  
      // COOKIE show/hide
      this.cookieButton.addEventListener("click", function (event) {
        event.preventDefault();
        self.resetButton();
        // NOTE: original code used this.cookiesMain (typo) but field is cookieMain.
        // Keeping original intent: show cookie main.
        self.cookieMain.classList.add("activ");
        self.cookieButton.classList.add("activ");
        self.listButton.classList.add("activ");
      });
    }
  
    resetButton() {
      this.tourapicGrid.classList.add("activeMenu");
      this.ui.classList.add("activeMenu");
      document.querySelectorAll(".main").forEach((element) => element.classList.remove("activ"));
  
      this.langButton.classList.remove("activ");
      this.helpButton.classList.remove("activ");
      this.daschuButton.classList.remove("activ");
      this.cookieButton.classList.remove("activ");
      this.listButton.classList.remove("activ");
      this.listButton.classList.remove("notClose");
      this.impButton.classList.remove("activ");
    }
  
    setDisplay(display) {
      this.mainWrap.style.display = display;
      this.header.style.display = display;
      this.ui.style.display = display;
      this.footer.style.display = display;
    }
  
    startTap() {
      switch (this.emap.cfg.mode) {
        case "expert":
        case "edit":
          break;
        case "raw":
          break;
        default:
          document.querySelector("#startscreen").classList.remove("ol");
          document.querySelector(".tourapic.intro").classList.remove("intro");
          this.tourapicGrid.style.display = "grid";
      }
  
      // NOTE: `collection` is global in your original code; kept as-is.
      const selectedZap = this.generalConfig.singleZapMode
        ? this.generalConfig.selectedZap
        : collection.zaps[0];
  
      this.emap.initTap({
        selectedZap,
        layout: {
          height: this.tapView.clientHeight,
          width: this.tapView.clientWidth,
          oheight: 0,
          owidth: 0,
          display: "large",
          offsetY: 0,
        },
        lng: this.UI.cfg.lng,
        contentLng: this.UI.cfg.contentLng,
      });
    }
  
    // ÜBERSICHT show/hide
    openUebersicht(event) {
      event.preventDefault();
      this.uebersichtWrap.classList.add("ol");
      this.startscreenUnten.classList.add("nol");
      this.tourapicGrid.classList.add("fromStart");
    }
  
    closeUebersicht(event) {
      event.preventDefault();
      if (this.tourapicGrid.classList.contains("fromStart")) {
        this.uebersichtWrap.classList.remove("ol");
        this.startscreenUnten.classList.remove("nol");
        this.tourapicGrid.style.display = "grid";
      } else {
        this.startscreenUnten.classList.remove("nol");
        this.startscreen.classList.remove("ol");
        this.uebersichtWrap.classList.remove("ol");
        this.tourapicGrid.style.display = "grid";
        this.startscreen.style.display = "none";
        this.uebersichtWrap.style.display = "none";
      }
    }
  
    closeUebersicht2() {
      this.tourapicGrid.classList.remove("activeMenu");
      this.tourapicGrid.style.display = "grid";
  
      this.ui.classList.remove("activeMenu");
      this.startscreenUnten.classList.remove("nol");
      this.startscreen.classList.remove("ol");
      this.uebersichtWrap.classList.remove("ol");
      this.startscreen.style.display = "none";
      this.uebersichtWrap.style.display = "none";
      document.querySelectorAll(".main").forEach((element) => element.classList.remove("activ"));
      this.contentMain.classList.add("activ");
      this.tourapicGrid.classList.remove("fromStart");
    }
  
    checkLang(lng) {
      this.currentLng = lng;
      this.contentLng = lng;
      this.tourapicGrid.classList.remove("activeMenu");
      document.querySelectorAll(".main").forEach((element) => element.classList.remove("activ"));
      this.daschuButton.classList.remove("activ");
      this.impButton.classList.remove("activ");
      this.listButton.classList.remove("activ");
      this.listButton.classList.remove("notClose");
      this.contentMain.classList.add("activ");

      this.initUebersichtGrid(this.currentLng);
      this.initTapGridRoot();
      this.initAllInfosByTour(this.currentStory);
      this.updateNavigation();
      this.setHeader();
      
    }
  
    showMenu() {
      this.sprachMenu.classList.add("ol");
    }
  
    hideMenu() {
      this.sprachMenu.classList.remove("ol");
    }
  
    setHeader() {
      const headline = document.querySelector(".headline h1");
      const lng = this.contentLng;
      headline.innerHTML = this.data.RAW.lngs[lng] ? this.data.RAW.lngs[lng].title : "";
    }
  
    setLogo() {
      const logo = document.querySelector(".logo img");
      const path = this.data.RAW.rootpath + this.data.RAW.path + this.data.RAW.logo;
      logo.src = path;
    }
  
    initSprachen() {
      const sprachDivs = document.querySelectorAll(".sprachMenu");
      const self = this;
      let i = 0;
      let lng = null;
  
      this.data.RAW.locales.forEach((item) => {
        sprachDivs.forEach((sprachDiv) => {
          const a = document.createElement("a");
          a.classList.add("flag", "local");
          a.title = item;
          a.id = item;
          a.setAttribute("data-attr", item);
  
          sprachDiv.appendChild(a);
  
          if (i === 0) {
            a.classList.add("spracheAktiv");
            lng = item;
          }
  
          a.addEventListener("click", function (event) {
            event.preventDefault();
            document.querySelectorAll(".sprachMenu a.flag").forEach((el) => {
              el.classList.remove("spracheAktiv");
            });
            event.currentTarget.classList.add("spracheAktiv");
            self.checkLang(event.currentTarget.id);
          });
  
          const img = document.createElement("img");
          img.alt = item;
          img.src = "./images/flags/" + item + ".svg";
          img.classList.add("flag");
          a.appendChild(img);
        });
  
        i++;
      });
  
      this.contentLng = lng;
    }
  
    initUebersichtGrid(lng) {
      if (!this.generalConfig.singleZapMode) {
        const self = this;
        const overViewDiv = document.querySelector("#uebersichtGrid");
  
        collection.zaps.forEach((item) => {
          const divItem = document.createElement("a");
          divItem.classList.add("uebersichtItem");
  
          const a = document.createElement("a");
          a.classList.add("usItem");
          a.onclick = () => {
            self.clickInfo(item.path);
          };
  
          const img = document.createElement("img");
          img.src =
            this.generalConfig.general.rootpath +
            this.generalConfig.general.basepath +
            item.thumbnailPath;
  
          if (item.lngs[lng]) {
            img.alt = item.lngs[lng].title;
            a.textContent = item.lngs[lng].title;
          }
  
          divItem.appendChild(a);
          divItem.appendChild(img);
          overViewDiv.appendChild(divItem);
        });
      }
    }
  
    initTapGridRoot() {
      if (!this.generalConfig.singleZapMode) {
        const lng = this.currentLng;
        const overViewDiv = this.tapsMain;
        const ul = document.createElement("ul");
        ul.id = "tapgridroot";
        overViewDiv.appendChild(ul);
  
        const self = this;
        collection.zaps.forEach((item) => {
          const li = document.createElement("li");
          ul.appendChild(li);
  
          const div = document.createElement("div");
          div.classList.add("raum");
          li.appendChild(div);
          li.id = "tapid_" + item.id;
  
          const img = document.createElement("img");
          img.src =
            this.generalConfig.general.rootpath +
            this.generalConfig.general.basepath +
            item.thumbnailPath;
          img.width = 60;
          img.height = 60;
  
          const a = document.createElement("a");
          a.classList.add("usItem");
          a.onclick = () => {
            self.clickInfo(item.path, "tap");
            self.resetButton();
          };
  
          if (item.lngs[lng]) {
            img.alt = item.lngs[lng].title;
            a.textContent = item.lngs[lng].title;
          }
  
          div.appendChild(img);
          div.appendChild(a);
  
          const infos = document.createElement("ul");
          infos.id = "tap_infos";
          li.appendChild(infos);
        });
      }
    }
  
    initTapGrid(tap) {
      const ul = document.getElementById("tapgridroot");
  
      // remove all tap items
      for (const li of ul.children) {
        const ulInfos = li.querySelector("#tap_infos");
        while (ulInfos && ulInfos.firstChild) {
          ulInfos.removeChild(ulInfos.firstChild);
        }
      }
  
      const selector = "#tapid_" + tap.id;
      const li = ul.querySelector(selector);
      const ul2 = li ? li.querySelector("#tap_infos") : ul;
  
      this.initTours(this.currentLng, tap, ul2);
    }
  
    initInfos(lng, tap, ul) {
      const self = this;
  
      for (const key in tap.infoMap) {
        if (Object.prototype.hasOwnProperty.call(tap.infoMap, key)) {
          const item2 = tap.infoMap[key];
  
          // NOTE: original uses global `infoIds` instead of `this.infoIds`; keep behavior but fix to instance.
          if (!this.infoIds.includes(item2.id)) {
            const il2 = document.createElement("li");
            ul.appendChild(il2);
  
            const a2 = document.createElement("a");
            a2.onclick = () => self.clickInfo(item2.id, "info");
  
            a2.textContent = item2.lngs[lng].title;
            il2.appendChild(a2);
          }
        }
      }
    }
  
    initTours(lng, tap, ul) {
      const tourMap = tap.tourMap;
  
      for (const key in tourMap) {
        const tour = tourMap[key];
        const il = document.createElement("il");
        ul.appendChild(il);
        il.textContent = tour.lngs[lng].title;
        const ul2 = document.createElement("ul2");
        il.appendChild(ul2);
        this.initTour(lng, tourMap[key], ul2);
      }
    }
  
    initTour(lng, tour, ul) {
      const self = this;
      const zaps = tour.zaps;
      const zap = zaps[0];
      const ovs = zap.overlays;
  
      for (let i = 0; i < ovs.length; ++i) {
        const info = this.UI.logic.getInfoForOverlayID(ovs[i]);
  
        if (info) {
          const il2 = document.createElement("li");
          ul.appendChild(il2);
  
          const a2 = document.createElement("a");
          a2.onclick = () => self.clickInfo(info.id, "info");
  
          a2.textContent = info.lngs[lng].title;
          il2.appendChild(a2);
        }
      }
    }
  
    initImpressum() {}
    initDatenschutz() {}
    initCookies() {}
  
    clickInfo(id, type) {
      const event = new Event("clickInfo");
      event.detail = { id, type: type ? type : "tap" };
      window.dispatchEvent(event);
    }
  
    scrollToInfoItem(id) {
      const targetSection = document.querySelector(`#${CSS.escape(id)}`);
      const scrollContainer = document.querySelector(".content.main.scroll-container.activ");
  
      if (scrollContainer) {
        scrollContainer.scrollTo({
          top: (targetSection ? targetSection.offsetTop : 0) - scrollContainer.offsetTop,
          behavior: "smooth",
        });
      }
    }
  
    setSectionHeight() {
      const sections = document.querySelectorAll(".scroll-container section");
      const self = this;
  
      if (sections.length > 0)
        sections.forEach((section) => {
          if (section && section.h1 && section.div && self.mainWrap)
            section.style.height =
              section.h1.clientHeight + section.div.clientHeight + self.mainWrap.clientHeight + "px";
        });
    }
  
    updateActiveSection() {
      const self = this;
      const container = document.querySelector(".mainWrap");
      const sections = document.querySelectorAll(".scroll-container section");
      let closest = null;
      let minOffset = Infinity;
      const offsetHeight = container.offsetTop;
  
      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        const offset = Math.abs(rect.top - offsetHeight);
        if (offset < minOffset) {
          minOffset = offset;
          closest = section;
        }
      });
  
      if (closest && closest.id !== self._lastActiveId) {
        self._lastActiveId = closest.id;
        closest.classList.add("active");
  
        sections.forEach((sec) => {
          if (sec !== closest) sec.classList.remove("active");
        });
  
        self.showOv(closest.id, "info");
      }
    }
  
    async showOv(id) {
      this.updateNavigation(id);
      const overlayMap = this.data.overlayMap;
  
      for (const key in overlayMap) {
        if (Object.prototype.hasOwnProperty.call(overlayMap, key)) {
          const ov = overlayMap[key];
          // NOTE: _zap_global is global in original code; kept as-is.
          // eslint-disable-next-line no-undef
          if (this.getActionByContent(id, ov)) {
            const zoomMul = ov?.target?.zoom ?? ov?.zoom ?? 1;
  
            await window.overlayHighlighter.highlightOverlay({ overlayId: ov.id, polyIndex: ov.polyIndex, zoomMul });
            return;
          }
        }
      }
    }
  
    getActionByContent ( content, ov){
        if (!ov)
            return null;
        for (var i=0;i<ov.actions.length;i++) {
            if (ov.actions[i].content==content) {
                return ov.actions[i];
            }
        }
        return null;
    }

    addSection(info, lng, isLast) {
      const self = this;
      info.index = this.infoList.length;
      info.isLast = isLast;
      this.infoList.push(info);
  
      const section = document.createElement("section");
      section.id = info.id;
  
      const h1 = document.createElement("h1");
      h1.id = info.id;
  
      const infoLng = info.lngs[lng];
  
      h1.textContent = infoLng ? infoLng.title : "";
      //info.div.innerHTML = infoLng ? infoLng.content : "";
  
      section.appendChild(h1);
      section.appendChild(info.div);
  
      this.contentMain.appendChild(section);
  
      section.waitUntilRenderedAndLoaded(function () {
        const h = h1.clientHeight;
        const d = info.div.clientHeight;
        const m = info.isLast
          ? Math.max(self.mainWrap.clientHeight - info.div.clientHeight, 0)
          : self.mainWrap.clientHeight / 3;
  
        section.style.height = h + d + m + "px";
      });
  
      return section;
    }
  
    initAllInfosByTour(story) {
  
      if (!story) return;
  
      const self = this;
      const lng = this.contentLng;
  
      while (this.contentMain.firstChild) {
        this.contentMain.removeChild(this.contentMain.firstChild);
      }
  
      //this.contentMain.style.display = "block";
      this.infoList = [];
      this.infoMap = {};
  
      const _story = this.getItem(story);
      
      if (_story) this.addSection(_story, lng, false);
  
      for (let i = 0; i < story.infos.length; ++i) {
        const info = story.infos[i];
        this.infoMap[info.id]=info;
        const _info = this.getItem(info);
        if (_info) this.addSection(_info, lng, i + 1 === story.infos.length);
      }
  
      document.querySelector(".scroll-container").addEventListener("scroll", () => {
        clearTimeout(self._scrollTimer);
        self._scrollTimer = setTimeout(self.updateActiveSection.bind(self), 100);
      });

      const el = document.querySelector(".scroll-container");
      //el.style.height = "400px";
    }
  
    updateNavigation(infoId) {
        const info = this.infoMap[infoId];
    
      const index = info ? info.index : 0;
  
      const nextinfo = this.infoList[index + 1];
      const previnfo = this.infoList[index - 1];
      const lng = this.contentLng;
  
      if (previnfo == null) {
        this.back.classList.add("backInactive");
        this.back.classList.remove("back");
      } else {
        this.back.classList.remove("backInactive");
        this.back.classList.add("back");
      }
  
      if (nextinfo == null) {
        this.next.classList.add("nextInactive");
        this.next.classList.remove("next");
      } else {
        this.next.classList.remove("nextInactive");
        this.next.classList.add("next");
      }
  
      const pLng = previnfo ? previnfo.lngs[lng] : null;
      const nLng = nextinfo ? nextinfo.lngs[lng] : null;
  
      this.back.firstChild.innerHTML = pLng ? pLng.title : "";
      this.next.firstChild.innerHTML = nLng ? nLng.title : "";
      this.next.setAttribute("data-type", nextinfo ? "info" : "startOfTour");
    }
   
    getItem(item){

        if (!item)
            return null;
        var lng = this.contentLng;
        
        const content = item["lngs"][lng] && item["lngs"][lng]["content"] ? item["lngs"][lng]["content"] : "";
    
        const div = this.convertTextToHtmlBlocks(item.ishtml, content, lng, this.data.mediaMap);
        item.div = div;

        return item;
    }

    convertTextToHtmlBlocks (isHtml, text, lng, mediaMap) {
        const container = document.createElement("div");
    
        // Split by double line breaks into blocks
        const blocks = text.trim().split(/\r\n/);
    
        blocks.forEach(block => {
            const mediaMatch = block.match(/%media_(.*?)%/);
    
            if (mediaMatch) {
                const code = mediaMatch[1];
                var mediaItem = mediaMap[code];
                if (mediaItem) {
    
                    const figure = document.createElement("figure");
    
                    const img = document.createElement("img");
    
                    img.src = this.data.RAW.rootpath+this.data.RAW.path+"media/"+mediaItem.file; // ← Passe Pfad/Erweiterung an
                    img.alt = mediaItem["lngs"][lng]["subtitle"];
    
                    const caption = document.createElement("figcaption");
                    caption.textContent = mediaItem["lngs"][lng]["subtitle"];
    
                    figure.appendChild(img);
                    figure.appendChild(caption);
                    container.appendChild(figure);
                }
            } else {
                const p = document.createElement("p");
                if (isHtml)
                    p.innerHTML = block.trim();
                else
                    p.textContent = block.trim();
                container.appendChild(p);
            }
        });
    
        return container;
    }
    
  }
  
  /* ===== keep your helpers (same as original) ===== */
  
  HTMLElement.prototype.waitUntilRenderedAndLoaded = function (callback) {
    const el = this;
    const images = el.querySelectorAll("img");
    let remaining = images.length;
  
    const finish = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          callback.call(el);
        });
      });
    };
  
    if (remaining === 0) {
      finish();
      return;
    }
  
    images.forEach((img) => {
      const done = () => {
        remaining--;
        if (remaining === 0) finish();
      };
  
      if (img.complete) {
        done();
      } else {
        img.addEventListener("load", done, { once: true });
        img.addEventListener("error", done, { once: true });
      }
    });
  };
  
  HTMLElement.prototype.waitUntilRenderedAndLoadedAsync = function () {
    return new Promise((resolve) => {
      this.waitUntilRenderedAndLoaded(resolve);
    });
  };

  